(function () {

  // Cookie helpers
  function setCookie(name, value) {
    document.cookie = name + '=' + encodeURIComponent(JSON.stringify(value)) + '; path=/';
  }

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    if (!match) return null;

    try {
      return JSON.parse(decodeURIComponent(match[1]));
    } catch (e) {
      return null;
    }
  }

  // The saved URL comes out of a cookie, which any subdomain can write, and
  // location.href will run a javascript: URI in this origin. Only ever navigate
  // to a same-origin collection path.
  function isSafeCollectionUrl(url) {
    return typeof url === 'string' &&
      /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?collections\/[a-z0-9][a-z0-9\-_]*$/i.test(url);
  }

  // The cart's "Continue shopping" points at /collections/all, which is outside
  // the punchout catalog. In the drawer, do exactly what the X does; on the
  // /cart page there's no drawer, so go back to the last collection instead.
  var CONTINUE_SHOPPING_SELECTOR = 'a[href$="/collections/all"]';
  var DRAWER_SELECTOR = 'cart-drawer, #CartDrawer, .cart-drawer, .drawer';
  var DRAWER_CLOSE_SELECTOR = '.drawer__close, [aria-label="Close"], [aria-label="Close cart"]';

  function getReturnCollectionUrl() {
    var candidates = [getCookie('punchout_collection'), getCookie('punchout_main_collection')];
    for (var i = 0; i < candidates.length; i++) {
      if (candidates[i] && isSafeCollectionUrl(candidates[i].url)) return candidates[i].url;
    }
    return null;
  }

  // Delegated on document (capture phase) so it survives the drawer being
  // re-rendered after add to cart / remove, and runs before any theme handler.
  document.addEventListener('click', function (event) {
    if (!document.body || !document.body.classList.contains('punchout')) return;

    var link = event.target.closest(CONTINUE_SHOPPING_SELECTOR);
    if (!link) return;

    var drawer = link.closest(DRAWER_SELECTOR);
    var inCartPage = link.closest('.cart__warnings, #main-cart-items, .cart__contents');
    if (!drawer && !inCartPage) return; // not a cart link (e.g. a menu item)

    event.preventDefault();

    if (drawer) {
      var closeButton = drawer.querySelector(DRAWER_CLOSE_SELECTOR);
      if (closeButton) {
        closeButton.click();
        return;
      }
      if (typeof drawer.close === 'function') {
        drawer.close();
        return;
      }
    }

    var url = getReturnCollectionUrl();
    window.location.href = url || link.href;
  }, true);

  // "Back" link for punchout buyers, placed where a breadcrumb would sit:
  //   product page            -> last visited collection (punchout_collection)
  //   non-main collection     -> main collection (punchout_main_collection)
  //   main collection / other -> no link
  function isProductPage() {
    return /\/products\/[^\/]+\/?$/.test(window.location.pathname);
  }

  function getCurrentCollectionHandle() {
    var match = window.location.pathname.match(/\/collections\/([^\/]+)\/?$/);
    return match ? decodeURIComponent(match[1]) : null;
  }

  function isUsableCollection(saved) {
    return !!saved && isSafeCollectionUrl(saved.url);
  }

  function getBackTarget() {
    var last = getCookie('punchout_collection');
    var main = getCookie('punchout_main_collection');

    if (isProductPage()) {
      if (isUsableCollection(last)) return last;
      if (isUsableCollection(main)) return main;
      return null;
    }

    var handle = getCurrentCollectionHandle();
    if (handle && isUsableCollection(main) && handle !== main.handle) return main;

    return null;
  }

  function renderPunchoutBackLink() {
    if (document.querySelector('.punchout-back')) return;

    var target = getBackTarget();
    if (!target) return;

    var main = document.getElementById('MainContent') || document.querySelector('main');
    if (!main) return;

    var nav = document.createElement('nav');
    nav.className = 'punchout-back page-width';
    nav.setAttribute('aria-label', 'Back');

    var link = document.createElement('a');
    link.className = 'punchout-back__link';
    link.href = target.url;
    // Title comes from a cookie: textContent, never innerHTML.
    link.textContent = '← Back to ' +
      (typeof target.title === 'string' && target.title ? target.title : 'collection');

    nav.appendChild(link);
    main.insertAdjacentElement('afterbegin', nav);
  }

  function initPunchoutCollection() {
    var data = window.punchoutData || {};
    var collectionHandle = data.collectionHandle || null;
    var collectionUrl = data.collectionUrl || null;
    var collectionTitle = data.collectionTitle || null;

    // Save current collection (always updated)
    if (collectionHandle) {
      setCookie('punchout_collection', {
        handle: collectionHandle,
        url: collectionUrl,
        title: collectionTitle
      });
    }

    // Save "main" collection only once — never overwritten
    if (collectionHandle && !getCookie('punchout_main_collection')) {
      setCookie('punchout_main_collection', {
        handle: collectionHandle,
        url: collectionUrl,
        title: collectionTitle
      });
    }

    // Retrieve saved collection and redirect if not on a collection page
    var savedCollection = getCookie('punchout_collection');
    if (savedCollection && isSafeCollectionUrl(savedCollection.url)) {
      if (window.location.pathname === '/' || window.location.pathname === '/account') {
        window.location.href = savedCollection.url;
      }
    }
  }


  function hidePunchoutSearch() {
    if (document.body.classList.contains('punchout')) {
      document.documentElement.classList.add('punchout');
      
      // Everything that used to be hidden here now lives in the punchout style
      // block in theme.liquid, keyed on body.punchout. Those rules apply the
      // moment TradeCentric sets the class, with no JS hop in between, and they
      // survive the section re-render that add to cart triggers.

      // No CSS equivalent: this hides only the FIRST .shopify-section on the
      // page. Giving that section a class of its own would let it move too.
      const shopifySection = document.querySelector('.shopify-section');
      if (shopifySection) shopifySection.style.display = 'none';

      const headerContainer = document.querySelector('.header');
      const policiesContainer = document.querySelector('.policies');

      // The logo the theme already rendered links to the homepage, which punchout
      // users shouldn't reach, so the link above is hidden. Re-insert an unlinked
      // copy of that same image rather than pointing at a hardcoded CDN URL.
      const storeLogo = document.querySelector('.header__heading-logo');
      if (headerContainer && storeLogo) {
        const punchoutLogo = storeLogo.cloneNode(true);
        punchoutLogo.removeAttribute('id');
        punchoutLogo.classList.add('punchout-logo');
        headerContainer.insertAdjacentElement('afterbegin', punchoutLogo);
      }

      if (policiesContainer) {
        policiesContainer.insertAdjacentHTML(
          'afterbegin',
          '<ul class="policies list-unstyled flex items-center"><li><small class="copyright__content"><a href="https://thelifeguardstore.com/pages/sizing-charts" target="_blank" class="copyright-text extra_small">Size Charts</a></small></li></ul>'
        );
      }

      // Handle collection session. Release the observer even if this throws, so a
      // bad cookie can't leave it re-firing on every class change.
      try {
        initPunchoutCollection();
        renderPunchoutBackLink();
      } finally {
        observer.disconnect(); // stop watching once done
      }
    }
  }

  const observer = new MutationObserver(hidePunchoutSearch);

  document.addEventListener('DOMContentLoaded', function () {
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });

    // Also run immediately in case class is already there
    hidePunchoutSearch();
  });

})();